var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssignmentsEmptySearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 165,
    viewBox: "0 0 229 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117,
    cy: 80,
    r: 80,
    fill: "#EAECF0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 20,
    r: 8,
    fill: "#F2F4F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 126,
    r: 6,
    fill: "#F2F4F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 138,
    r: 10,
    fill: "#F2F4F7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 217,
    cy: 38,
    r: 10,
    fill: "#F2F4F7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 11,
    r: 7,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_510_49646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0783 124.215L115.53 99.7561C118.163 98.5281 119.302 95.3978 118.074 92.7643L87.0988 26.337L66.1234 18.7026L23.2087 38.714C20.5753 39.942 19.4359 43.0723 20.6639 45.7058L56.0865 121.67C57.3145 124.303 60.4448 125.443 63.0783 124.215Z",
    fill: "url(#paint0_linear_510_49646)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.123 18.7031L87.0984 26.3375L72.7935 33.008L66.123 18.7031Z",
    fill: "#D0D5DD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_510_49646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.1519 106.339H146.025C148.931 106.339 151.287 103.984 151.287 101.078V27.7837L135.503 12H88.1519C85.2462 12 82.8906 14.3555 82.8906 17.2612V101.078C82.8906 103.984 85.2462 106.339 88.1519 106.339Z",
    fill: "url(#paint1_linear_510_49646)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.503 12L151.287 27.7837H135.503V12Z",
    fill: "#D0D5DD"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_510_49646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.91 99.724L170.362 124.182C172.995 125.41 176.126 124.271 177.354 121.638L208.329 55.2103L200.695 34.2349L157.78 14.2235C155.147 12.9955 152.016 14.1348 150.788 16.7683L115.366 92.7322C114.138 95.3657 115.277 98.496 117.91 99.724Z",
    fill: "url(#paint2_linear_510_49646)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.694 34.2344L208.329 55.2098L194.024 48.5393L200.694 34.2344Z",
    fill: "#D0D5DD"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_510_49646)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 88,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#344054",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.689 114.904C108.689 111.038 111.823 107.904 115.689 107.904C119.555 107.904 122.689 111.038 122.689 114.904C122.689 116.79 121.944 118.502 120.731 119.76C120.697 119.787 120.664 119.816 120.632 119.847C120.601 119.879 120.572 119.912 120.546 119.946C119.287 121.159 117.575 121.904 115.689 121.904C111.823 121.904 108.689 118.77 108.689 114.904ZM121.307 121.936C119.767 123.168 117.814 123.904 115.689 123.904C110.719 123.904 106.689 119.875 106.689 114.904C106.689 109.934 110.719 105.904 115.689 105.904C120.66 105.904 124.689 109.934 124.689 114.904C124.689 117.029 123.953 118.982 122.721 120.522L126.396 124.197C126.787 124.588 126.787 125.221 126.396 125.611C126.006 126.002 125.373 126.002 124.982 125.611L121.307 121.936Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_510_49646",
    x: -1.55957,
    y: 12.0312,
    width: 141.857,
    height: 154.406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_510_49646"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_510_49646"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_510_49646"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_510_49646",
    result: "effect2_dropShadow_510_49646"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_510_49646",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_510_49646",
    x: 62.8906,
    y: 12,
    width: 108.396,
    height: 134.34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_510_49646"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_510_49646"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_510_49646"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_510_49646",
    result: "effect2_dropShadow_510_49646"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_510_49646",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_510_49646",
    x: 93.1426,
    y: 12,
    width: 141.857,
    height: 154.406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_510_49646"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_510_49646"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_510_49646"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_510_49646",
    result: "effect2_dropShadow_510_49646"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_510_49646",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_510_49646",
    x: 81,
    y: 80,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_510_49646"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_510_49646",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_510_49646",
    x1: 59.9968,
    y1: 124.419,
    x2: 18.1972,
    y2: 49.0097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_510_49646",
    x1: 85.2725,
    y1: 105.223,
    x2: 79.2587,
    y2: 19.2131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_510_49646",
    x1: 115.773,
    y1: 97.4951,
    x2: 146.672,
    y2: 17.0024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FAFB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignmentsEmptySearch);
export default __webpack_public_path__ + "static/media/assignments_empty_search.aae5895449f1dd2433d9b328b9e0a70e.svg";
export { ForwardRef as ReactComponent };